import http from "./controllerFetch";

class ProdSituazione {
  get( params = {}) {
    return http.get('ProdSituazione/readProdSituazione', { params });
  }
  readQtMaxProd( params = {}) {
    return http.get('ProdSituazione/readQtMaxProd', { params });
  }
  readProdSituazioneOld( params = {}) {
    return http.get('ProdSituazione/readProdSituazioneOld', { params });
  }
  readStoricoProd( params = {}) {
    return http.get('ProdSituazione/readStoricoProd', { params });
  }
  ultimiInvProd( params = {}) {
    return http.get('ProdSituazione/ultimiInvProd', { params });
  }
  readProdSituazioneMagazzino( params = {}) {
    return http.get('ProdSituazione/readProdSituazioneMagazzino', { params });
  }
  spostaProdSituazione(data) {
    return http.post('ProdSituazione/spostaProdSituazione', data);
}

}

export default new ProdSituazione();